import { render } from "./PwpFooter.vue?vue&type=template&id=2380884f&scoped=true"
import script from "./PwpFooter.vue?vue&type=script&lang=js"
export * from "./PwpFooter.vue?vue&type=script&lang=js"

import "./PwpFooter.vue?vue&type=style&index=0&id=2380884f&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2380884f"]])

export default __exports__